import { Record } from 'immutable';
import { schema } from 'normalizr';

import { customerSchema } from '@sophocles/entities/Customer/customerRecord';
import { siteGroupWeatherConfigurationSchema } from '@sophocles/entities/SiteGroupWeatherConfiguration';

export const SiteGroup = new Record({
  id: null,
  name: 'no name',
  description: 'no descrip',
  is_virtual: null,
  is_inventory: false,
  customer: null,
  custom_data: {},
  application: 0,
  options: {},
  weather_configuration: null,
  deactivated: false,
});

export const siteGroupSchema = new schema.Entity('siteGroups', {
  customer: customerSchema,
  weather_configuration: siteGroupWeatherConfigurationSchema,
});
